import {RequestedFilterModel} from '@app/core/model/integration-models';

export class RulesAndTransforms {
    rules: RequestedFilterModel[] = [];
    transforms: RequestedFilterModel[] = [];
}
